import api from './api';
import { 
  LicenzaSimple, 
  SearchLicenzeRequest, 
  PagedLicenzeResponse, 
  LicenzeStats 
} from '../types/licenze';

// API per la gestione delle licenze
export const licenzeApi = {
  // Cerca licenze con paginazione e filtri
  searchLicenze: async (searchRequest: SearchLicenzeRequest): Promise<PagedLicenzeResponse> => {
    try {
      const response = await api.post<PagedLicenzeResponse>('/licenzesimple/search', searchRequest);
      return response.data;
    } catch (error: any) {
      console.error('Errore nella ricerca licenze:', error);
      throw new Error(error.response?.data?.message || 'Errore nella ricerca licenze');
    }
  },

  // Ottieni licenza per username
  getLicenzaByUsername: async (username: string): Promise<LicenzaSimple> => {
    try {
      const response = await api.get<LicenzaSimple>(`/licenzesimple/${encodeURIComponent(username)}`);
      return response.data;
    } catch (error: any) {
      console.error('Errore nel recupero licenza:', error);
      throw new Error(error.response?.data?.message || 'Errore nel recupero licenza');
    }
  },

  // Ottieni statistiche licenze
  getStats: async (): Promise<LicenzeStats> => {
    try {
      const response = await api.get<LicenzeStats>('/licenzesimple/stats');
      return response.data;
    } catch (error: any) {
      console.error('Errore nel recupero statistiche licenze:', error);
      throw new Error(error.response?.data?.message || 'Errore nel recupero statistiche licenze');
    }
  },

  // Ottieni tipi di licenza disponibili
  getTipiLicenza: async (): Promise<string[]> => {
    try {
      const response = await api.get<string[]>('/licenzesimple/tipi');
      return response.data;
    } catch (error: any) {
      console.error('Errore nel recupero tipi licenza:', error);
      throw new Error(error.response?.data?.message || 'Errore nel recupero tipi licenza');
    }
  },

  // Ottieni licenze in scadenza
  getLicenzeInScadenza: async (giorni: number = 30): Promise<LicenzaSimple[]> => {
    try {
      const response = await api.get<LicenzaSimple[]>(`/licenzesimple/in-scadenza?giorni=${giorni}`);
      return response.data;
    } catch (error: any) {
      console.error('Errore nel recupero licenze in scadenza:', error);
      throw new Error(error.response?.data?.message || 'Errore nel recupero licenze in scadenza');
    }
  },

  // Ottieni licenze scadute
  getLicenzeScadute: async (giorni: number = 30): Promise<LicenzaSimple[]> => {
    try {
      const response = await api.get<LicenzaSimple[]>(`/licenzesimple/scadute?giorni=${giorni}`);
      return response.data;
    } catch (error: any) {
      console.error('Errore nel recupero licenze scadute:', error);
      throw new Error(error.response?.data?.message || 'Errore nel recupero licenze scadute');
    }
  },

  // Esporta licenze in CSV
  exportLicenze: async (searchRequest: SearchLicenzeRequest): Promise<Blob> => {
    try {
      const response = await api.post<Blob>('/licenzesimple/export', searchRequest, {
        responseType: 'blob'
      });
      return response.data as Blob;
    } catch (error: any) {
      console.error('Errore nell\'export licenze:', error);
      throw new Error(error.response?.data?.message || 'Errore nell\'export licenze');
    }
  },

  // Test connessione alla vista (solo per admin)
  testConnection: async (): Promise<any> => {
    try {
      const response = await api.get('/licenzesimple/test');
      return response.data;
    } catch (error: any) {
      console.error('Errore nel test connessione:', error);
      throw new Error(error.response?.data?.message || 'Errore nel test connessione');
    }
  }
};

// Helper per il download del file CSV
export const downloadCsvFile = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// Helper per formattare le date
export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('it-IT');
};

// Helper per formattare date e ora
export const formatDateTime = (dateString: string): string => {
  return new Date(dateString).toLocaleString('it-IT');
};

// Helper per ottenere la classe CSS in base allo stato licenza
export const getStatoLicenzaClass = (stato: string): string => {
  switch (stato.toLowerCase()) {
    case 'attiva':
      return 'stato-attiva';
    case 'scaduta':
      return 'stato-scaduta';
    case 'in attesa':
      return 'stato-in-attesa';
    default:
      return 'stato-unknown';
  }
};

// Helper per ottenere la classe CSS in base ai giorni rimanenti
export const getGiorniRimanentiClass = (giorni: number): string => {
  if (giorni < 0) return 'giorni-scaduta';
  if (giorni <= 7) return 'giorni-critico';
  if (giorni <= 30) return 'giorni-attenzione';
  return 'giorni-normale';
};